import type { User } from '../types';

export const isTalosUser = (user: Partial<User> | undefined): boolean => {
  if (!user || !('Roles' in user)) {
    return false;
  }
  return (user?.Roles ?? []).some(role => role.startsWith('talos.'));
};
